import React from 'react';
import style from './style';
import EAIcon from '../../../common/EAIcon';

const StepperMainInfo = ({ title, subtitle, text, singleTp }) => {
  const { classes } = style();

  return (
    <div>
      <h2 className={classes.title}>{title}</h2>
      {subtitle && <h3 className={classes.subTitle}>{subtitle}</h3>}
      {singleTp && <div className={classes.singleTp}>
        <EAIcon icon={"context/tpSheet/tp"}/>
        <div className={classes.infosTp}>
          <div className={classes.infosTpName}>{singleTp.name}</div>
          <div className={classes.infosTpFunction}>{singleTp.activityLabel}</div>
        </div>
      </div>}
      {text && <p className={classes.text}>{text}</p>}
    </div>
  );
};

export default StepperMainInfo;
